import script from "./ControlPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlPanel.vue?vue&type=script&setup=true&lang=js"

import "./ControlPanel.vue?vue&type=style&index=0&id=4516974e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4516974e"]])

export default __exports__